import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './styles.css';

/**
 *  SiteSearchPc
 */
class SiteSearchPc extends Component {
  static propTypes = {
    searchCode: PropTypes.string,
  };
  static defaultProps = {
    searchCode: null,
  };

  constructor(props) {
    super();
    this.props = props;
    this.state = {
      open: false,
      left: 0,
      width: 80,
    };
    this.windowWidth = null;
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  render() {
    return (
      <div className={'SiteSearch pc' + ((this.state.open === true) ? ' open': '')}>
        <div className="SiteSearch__container"
             style={{left: this.state.left - 21, width: this.state.width}}
        >
          <div className="SiteSearch__inner">
            <div className="SiteSearch__code"
                 ref="code"
            >
              {(this.props.searchCode !== null) ?
                <div dangerouslySetInnerHTML={{__html: this.props.searchCode}}/>: null}
            </div>
            <div className="SiteSearch__border">
              <a className="SiteSearch__link-close"
                 href="#"
                 onClick={(e) => {
                   this.handleClick(e)
                 }}
              />
            </div>
          </div>
        </div>
        <a className="SiteSearch__link-open"
           href="#"
           onClick={(e) => {
             this.handleClick(e)
           }}
        />
      </div>
    )
  }

  //
  handleClick = (e) => {
    e.preventDefault();
    //
    let search_input = null;
    const formElement = this.refs.code.getElementsByClassName('js-SearchForm')[0] || null;
    if (formElement) {
      search_input = formElement.querySelector('.js-SearchForm_kw')
    }
    if (this.state.open === true) {
      if (search_input) {
        search_input.blur();
      }
      //
      this.setState({
        open: false,
        left: 0,
        width: 80,
      });
    } else {
      if (search_input) {
        search_input.focus();
      }
      this.windowWidth = window.innerWidth;
      if (1360 < this.windowWidth) this.windowWidth = 1360;
      if (this.windowWidth < 1064) this.windowWidth = 1064;
      //
      this.setState({
        open: true,
        left: -this.windowWidth + (340 + 80),
        width: this.windowWidth - 340,
      });
    }
  };

}

export default SiteSearchPc



// WEBPACK FOOTER //
// ./src/containers/site-search/pc.jsx